/* eslint-disable */
import React from 'react';
import { ChartTypeDefinition } from '../../../helpers/chart-type.registry';
import { ChartTypeButton } from './ChartTypeButton';
import './ChartTypeGrid.scss';

interface ChartTypeGridProps {
	definitions: ChartTypeDefinition[];
	selectedType?: string;
	isSingleSeries: boolean;
	onSelectType: (type: string) => void;
}

export const ChartTypeGrid: React.FC<ChartTypeGridProps> = ({
	definitions,
	selectedType,
	isSingleSeries,
	onSelectType,
}) => {
	return (
		<div className="chart-type-grid">
			{definitions.map((def) => (
				<ChartTypeButton
					key={def.type}
					definition={def}
					isSelected={selectedType === def.type}
					onClick={onSelectType}
				/>
			))}
		</div>
	);
};
